import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  makeStyles,
  TableCell,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ReplyIcon from "@material-ui/icons/Reply";
import { dateFormated } from "../../functionalComponents/dataFormatFunctions";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ChevronRight } from "@material-ui/icons";
import PONegotiationDialogBox from "./PONegotiationDialogBox";
import { useDispatch } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { appUrl } from "../../../../../../utils/config";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import StyledButton from "../../models/Button";

const useStyles = makeStyles((theme) => ({
  responseBtn: {
    cursor: "pointer",
    fontSize: "large",
    //     '&:hover': {
    //         fontSize: 'medium',
    // },
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "80px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  dialogPaper: {
    borderRadius: "1rem",
  },
}));

const EditSponsorPOColumns = (props) => {
  const { row, handleRefresh, featuresAccess , showPencilIcon} = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  // const originalPO = useRef(row);
  const [successDialogBox, setSuccessDialogBox] = useState({
    openDialogBox: false,
    dialogBoxType: "",
  });
  const [saveFailed, setSaveFailed] = useState(false);
  const [negotiation, setNegotiation] = useState(false);
  const { roleName, organizationName, authToken } = localStorage;
  var token = authToken;
  var decoded = jwt_decode(token);

  // console.log(row, 'row')

  const handleNegotiation = (type) => {
    setNegotiation(false);
    if (type === "success") {
      setSuccessDialogBox({
        openDialogBox: true,
        dialogBoxType: "valueProposed",
      });
    } else if (type === "failed") {
      setSaveFailed(true);
    }
  };

  const handleSave = (type) => {
    dispatch({
      type: OPEN_BACKDROP,
      // backdropText: `Please don't refresh or close the tab while processing`,
    });

    // selectedLineitem = originalPO.current
    //   ? originalPO.current
    //       : {};

    let data = {
      vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
      scheduleAgreementStatusID: row?.scheduleLineDetails?.scheduleLineStatusID,
      scheduleAgreementStatusText:
        row?.scheduleLineDetails?.scheduleLineStatusText,
      schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
      scheduleAgreementNumber:
        row?.scheduleLineDetails?.scheduleAgreementNumber,
      vendorName: row?.scheduleLineDetails?.vendorName,
      sponsorName: row?.scheduleLineDetails?.sponsorName,
      productsList: row?.scheduleLineDetails
        ? [
            {
              fgMaterialCode: row?.scheduleLineDetails?.fgMaterialCode,
              fgMaterialName: row?.scheduleLineDetails?.fgMaterialName,
            },
          ]
        : [],
      poApprovedFlag: [21, 22, 23].includes(
        row?.scheduleLineDetails?.scheduleLineStatusID
      )
        ? false
        : true,
      poLineEditFlag:
        type === "AcceptOffer" || type === "revisedOfferAccepted"
          ? true
          : false,
      acceptOfferFlag:
        type === "AcceptOffer" || type === "revisedOfferAccepted"
          ? true
          : false,
      rejectOfferFlag: false,
      approveFlag: false,
      shareWithCMOFlag: type === "sharedWithCMO" ? true : false,
      confirmedFlag: false,
      SLDetails: {
        ...row?.scheduleLineDetails,
        // sponsorProposedDeliveryDate:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
        // sponsorProposedQuantity:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.sponsorProposedQuantity,

        // cmoProposedDeliveryDate:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.cmoProposedDeliveryDate,
        // cmoProposedQuantity:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.cmoProposedQuantity,

        // committedDeliveryDate:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? row?.scheduleLineDetails?.sponsorProposedDeliveryDate
        //     : row?.scheduleLineDetails?.committedDeliveryDate,
        // committedQuantity:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? row?.scheduleLineDetails?.sponsorProposedQuantity
        //     : row?.scheduleLineDetails?.committedQuantity,

        changeInQty: false,
        changeInDate: false,
        markedForDelete: false,
      },
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetailsNew`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setSuccessDialogBox({
            openDialogBox: true,
            dialogBoxType: type,
          });
        } else {
          setSaveFailed(true);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        setSaveFailed(true);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // console.log(err);
      });

    // setTimeout(() => {
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });
    //   setSuccessDialogBox({
    //     openDialogBox: true,
    //     dialogBoxType: type,
    //   });
    // }, 3000);
  };


  return (
    <React.Fragment>
      <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
        {row?.scheduleLineDetails?.sponsorProposedQuantity
          ? row?.scheduleLineDetails?.sponsorProposedQuantity
          : "NA"}
      </TableCell>

      <TableCell style={{ whiteSpace: "nowrap" }}>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "left",
          }}
        >
          {dateFormated(
            row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
            "DD-MMM-YYYY",
            "NA"
          )}
          {!(
            row?.scheduleLineDetails?.scheduleLineStatusID === 30 ||
            [9].includes(row?.batchDetails?.batchStatusID)
          ) && (
            <Box
              style={{ display: "flex", flexDirection: "column", gap: "3px" }}
            >
              {localStorage.collabType !== "CMO" &&
                featuresAccess?.editSponsorProposedValues &&
                props.showPencilIcon &&
                row?.scheduleLineDetails?.cmoToUsePOInterface === true && (
                  // && row?.scheduleLineDetails?.plannerEmailID ===decoded.email_address
                  <span title="Edit">
                    <EditIcon
                      fontSize="large"
                      style={{ color: "#ec6535", cursor: "pointer" }}
                      // className={classes.responseBtn}
                      onClick={() => {
                        setNegotiation(true);
                      }}
                    />
                  </span>
                )}
              {localStorage.collabType === "CMO" &&
                row?.scheduleLineDetails?.sponsorProposedQuantity &&
                row?.scheduleLineDetails?.sponsorProposedDeliveryDate &&
                // featuresAccess?.confirmSponsorProposedValues 
                // &&
                featuresAccess?.acceptOffer &&
                row?.scheduleLineDetails?.cmoToUsePOInterface === true && (
                  <span title="Accept">
                    <CheckCircleIcon
                      // CheckCircleOutlineIcon
                      fontSize="medium"
                      style={{
                        backgroundColor: "white",
                        color: "green",
                        fontWeight: "bold",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (
                          row?.scheduleLineDetails?.scheduleLineStatusID == 29
                        ) {
                          handleSave("revisedOfferAccepted");
                        } else {
                          handleSave("AcceptOffer");
                        }
                      }}
                      // className={classes.responseBtn}
                    />
                  </span>
                )}
              {/* {localStorage.collabType !== "CMO" &&
                row?.scheduleLineDetails?.scheduleLineStatusID === 21 && (
                  <span title="Share with CMO">
                    <ReplyIcon
                      onClick={() => handleSave("sharedWithCMO")}
                      className={classes.responseBtn}
                    />
                  </span>
                )} */}
            </Box>
          )}
        </Box>
      </TableCell>

      <Dialog
        open={successDialogBox.openDialogBox}
        disableBackdropClick // Disable closing on outside click
        disableEscapeKeyDown // Disable closing on escape key
        maxWidth="sm"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent className={classes.dialogContent}>
          {featuresAccess?.confirmSponsorProposedValues && (
            <CheckCircleIcon className={classes.avatar} />
          )}
          <Typography
            style={{
              marginTop: "10px",
              fontWeight: "600",
              color: "black",
              fontSize: "1.4rem",
            }}
          >
            {successDialogBox.dialogBoxType === "sharedWithCMO"
              ? "Shared the PO Details with CMO successfully"
              : successDialogBox.dialogBoxType === "AcceptOffer" &&
                localStorage.collabType === "CMO"
              ? "Sponsor proposal accepted"
              : successDialogBox.dialogBoxType === "valueProposed"
              ? "Updated successfully"
              : successDialogBox.dialogBoxType === "revisedOfferAccepted"
              // ? "Current agreed values for the PO updated as per sponsor proposed values"
              ? "Sponsor proposal accepted"
              : "Updated successfully"}
          </Typography>
          <DialogActions className={classes.dialogActions}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                textTransform: "none",
              }}
              onClick={() => {
                handleRefresh();
                setSuccessDialogBox({
                  openDialogBox: false,
                  dialogBoxType: "",
                });
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>

      {negotiation && (
        <PONegotiationDialogBox
          open={negotiation}
          handleClose={handleNegotiation}
          row={row}
        />
      )}
    </React.Fragment>
  );
};

export default EditSponsorPOColumns;
